export { default, getStaticPaths, getStaticProps } from '../../src/pages/Post'
